import { useEffect, useRef, useState } from 'react';

import { UseRewardDiscount } from './types';

/* one item may have a 'redeemable' flag. Only one item may be "redeemable". This is decided by the connector. */
const useRewardDiscount: UseRewardDiscount = ({ cartEntries, serverOrder }) => {
  const [redeemableItemsSet, setRedeemableItemsSet] = useState(new Set());
  const [cartHasRewardEligibleItem, setCartHasRewardEligibleItem] = useState(false);
  const redeemableItemsSetRef = useRef(new Set());
  redeemableItemsSetRef.current = redeemableItemsSet;

  // set cartHasRedeemableItem when cart changes
  useEffect(() => {
    const hasRewardEligibleItem = cartEntries.some(cartEntry => cartEntry.rewardEligible);
    setCartHasRewardEligibleItem(hasRewardEligibleItem);
  }, [cartEntries]);

  // update the redeemableItemsSet when server order changes
  useEffect(() => {
    if (!serverOrder || !serverOrder.cart) {
      return;
    }

    const redeemedItemSet = serverOrder.cart.cartEntries.reduce((acc, item) => {
      if (item.redeemable) {
        acc.add(item.lineId);
      }
      return acc;
    }, new Set());

    const areSetsEqual = (a: Set<string | unknown>, b: Set<string | unknown>) => {
      return a.size === b.size && Array.from(a).every(value => b.has(value));
    };

    const shouldUpdate =
      !redeemableItemsSetRef.current.size ||
      !areSetsEqual(redeemedItemSet, redeemableItemsSetRef.current);

    if (shouldUpdate) {
      setRedeemableItemsSet(redeemedItemSet);
    }
  }, [serverOrder]);

  return {
    cartHasRewardEligibleItem,
    redeemableItemsSet,
  };
};

export default useRewardDiscount;
